import { Layout } from "@/components/Layout";
import { useEffect } from "react";
import { HeroSection } from "@/components/sections/HeroSection";
import { ExperienceSection } from "@/components/sections/ExperienceSection";
import { ProjectsSection } from "@/components/sections/ProjectsSection";
import { SkillsSection } from "@/components/sections/SkillsSection";
import { ContactSection } from "@/components/sections/ContactSection";
import LazySection from "@/components/LazySection";

const Index = () => {
  useEffect(() => {
    // Update metadata
    document.title =
      "Aditya Kandele | Web Entusiast Frontend Focused Fullstack ";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Web Enthusiast - Frontend Focused Fullstack with over 15 years of experience and open source."
      );
    }
  }, []);

  return (
    <Layout>
      <div className="flex flex-col min-h-screen" role="main">
        <HeroSection />
        <LazySection>
          <ExperienceSection />
        </LazySection>
        <LazySection>
          <ProjectsSection />
        </LazySection>
        <LazySection>
          <SkillsSection />
        </LazySection>
        <LazySection>
          <ContactSection />
        </LazySection>
      </div>
    </Layout>
  );
};

export default Index;
